import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { grammarUserStateSchema } from '../schemas';

const getGrammarProgressV1DataSchemaDefinition = z.object({
  totalPoints: z.number().int().nonnegative(),
  states: z.array(grammarUserStateSchema),
});

export const getGrammarProgressV1DataSchema: typeof getGrammarProgressV1DataSchemaDefinition =
  getGrammarProgressV1DataSchemaDefinition;

export type IGetGrammarProgressV1Data = z.infer<typeof getGrammarProgressV1DataSchema>;

export const getGrammarProgressV1ResponseSchema: z.ZodSchema<IAPI<IGetGrammarProgressV1Data>> =
  createApiResponseSchema(getGrammarProgressV1DataSchema) as z.ZodSchema<
    IAPI<IGetGrammarProgressV1Data>
  >;

export type IGetGrammarProgressV1Response = IAPI<IGetGrammarProgressV1Data>;
